import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-color-secondary text-sm"
}
const _hoisted_2 = { class: "flex-1 min-w-0 p-fluid" }
const _hoisted_3 = {
  key: 0,
  class: "p-error"
}
const _hoisted_4 = { class: "p-inputgroup" }
const _hoisted_5 = {
  key: 0,
  class: "p-error block mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_PrimeVueInputText = _resolveComponent("PrimeVueInputText")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_PrimeVueDialog = _resolveComponent("PrimeVueDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("span", null, [
    _withDirectives(_createVNode(_component_PrimeVueButton, {
      class: "p-button-rounded p-button-outlined p-button-secondary ml-3 sm:ml-4",
      icon: "pi pi-folder",
      disabled: _ctx.disabled,
      onClick: _ctx.open
    }, null, 8, ["disabled", "onClick"]), [
      [
        _directive_tooltip,
        _ctx.$t('folders'),
        void 0,
        { left: true }
      ]
    ]),
    _createVNode(_component_PrimeVueDialog, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      header: _ctx.$t('folders'),
      modal: true,
      "dismissable-mask": true,
      style: { width: '30rem' }
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_PrimeVueInputText, {
            modelValue: _ctx.newFolderName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newFolderName) = $event)),
            modelModifiers: { trim: true },
            placeholder: _ctx.$t('new_folder'),
            disabled: _ctx.creating,
            onKeyup: _withKeys(_ctx.createFolder, ["enter"])
          }, null, 8, ["modelValue", "placeholder", "disabled", "onKeyup"]),
          _createVNode(_component_PrimeVueButton, {
            label: _ctx.$t('add'),
            icon: "pi pi-plus",
            loading: _ctx.creating,
            disabled: !_ctx.newFolderName,
            onClick: _ctx.createFolder
          }, null, 8, ["label", "loading", "disabled", "onClick"])
        ]),
        (_ctx.createError)
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.createError), 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (index) => {
              return _createVNode(_component_PrimeVueSkeleton, {
                class: "mb-2",
                key: index,
                height: "1.5rem"
              })
            }), 64))
          : (!_ctx.folders.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$t('no_folders')), 1))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.folders, (folder) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex align-items-center gap-2 mb-2",
                  key: folder.id
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_PrimeVueInputText, {
                      modelValue: folder.name,
                      "onUpdate:modelValue": ($event: any) => ((folder.name) = $event),
                      modelModifiers: { trim: true },
                      disabled: folder.saving,
                      onKeyup: _withKeys(($event: any) => (_ctx.renameFolder(folder.id)), ["enter"]),
                      onBlur: ($event: any) => (_ctx.renameFolder(folder.id))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onKeyup", "onBlur"]),
                    (folder.error)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(folder.error), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createVNode(_component_PrimeVueTag, {
                    class: "flex-shrink-0",
                    severity: "info",
                    value: String(folder.campaigns_count ?? 0)
                  }, null, 8, ["value"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('campaigns'),
                      void 0,
                      { top: true }
                    ]
                  ]),
                  _withDirectives(_createVNode(_component_PrimeVueButton, {
                    class: _normalizeClass(["flex-shrink-0 p-button-rounded p-button-text", folder.confirming ? 'p-button-danger' : 'p-button-secondary']),
                    icon: "pi pi-trash",
                    loading: folder.saving,
                    onClick: ($event: any) => (_ctx.deleteFolder(folder.id))
                  }, null, 8, ["loading", "class", "onClick"]), [
                    [
                      _directive_tooltip,
                      folder.confirming ? _ctx.$t('folder_delete_confirmation') : _ctx.$t('delete'),
                      void 0,
                      { right: true }
                    ]
                  ])
                ]))
              }), 128))
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}